/**
 * Reducer for the Lesson Planner admin slice. Mirrors preschoolEntity —
 * one entity-keyed AsyncSlot per entity, generic fetch/response helpers.
 */
import {
  commonStructure,
  handleEntitiesUpdate,
  dataResponseHandler,
  dataFetchingHandler
} from './reducer.helper'

import * as types from '../types/lessonPlannerEntity'

const initialState = {
  plannerGradeGroupData: commonStructure(),
  plannerSubjectData: commonStructure(),
  plannerLayoutData: commonStructure()
}

const lessonPlannerEntityReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_PLANNER_GRADE_GROUP_DATA:
    case types.FETCH_PLANNER_SUBJECT_DATA:
    case types.FETCH_PLANNER_LAYOUT_DATA:
      return dataFetchingHandler(state, `${action.entity}Data`, action)

    case types.FETCH_PLANNER_GRADE_GROUP_DATA_SUCCESS:
    case types.FETCH_PLANNER_SUBJECT_DATA_SUCCESS:
    case types.FETCH_PLANNER_LAYOUT_DATA_SUCCESS:
      return dataResponseHandler(state, `${action.entity}Data`, action)

    case types.UPDATE_PLANNER_DATA_SUCCESS:
      return handleEntitiesUpdate(state, action)

    default:
      return state
  }
}

export { lessonPlannerEntityReducer }
